<template>
	<header class="content-header">
		<h1 v-html="title">References</h1>
		<button class="back-button" id="back-button" @click="$router.go(-1)">
			<div class="back-arrow">
				<img src="@/assets/img/arrow-back-icon-white.svg" alt />
			</div>
			<div class="back-button-text">Back</div>
		</button>
	</header>
</template>

<script>
export default {
  name: 'page-header',
  props: {
		title: String
  }
};
</script>

<style lang="scss" scoped>
@import '~@/scss/styles.scss';

.content-header {
		display: flex;
		justify-content: space-between;
		color: $white;
		padding: rem(25px) 0;
		h1 {
			font-size: rem(30px);
		}
	}
	
	.back-button {
		color: $white;
		display: flex;
		align-items: center;
		cursor: pointer;
		background: transparent;
    border: none;
		.back-arrow {
			width: 20px;
			height: 20px;
			margin-right: 10px;
			img {
				width: 100%;
			}
		}
		.back-button-text {
			font-size: rem(14px);
		}
	}
</style>
